import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { AuthCard } from "@/components/auth/AuthCard";

export default function ResetPassword() {
  const { token } = useParams();
  const [email, setEmail] = useState(null);
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    api.get(`/auth/reset-password/${token}`).then(({ data }) => setEmail(data.email)).catch((e) => setError(formatApiError(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (error || done) {
    return (
      <AuthCard testid="reset-panel">
        <h1 className="font-display text-2xl font-bold text-oath-ink" data-testid="reset-result">{done ? "Password updated" : "Link unavailable"}</h1>
        <p className="mt-3 text-sm text-oath-secondary">{done ? "You can now sign in with your new password." : error}</p>
        <Link to="/signin" className="mt-6 inline-block text-sm text-oath-accent underline" data-testid="reset-signin-link">Go to sign in</Link>
      </AuthCard>
    );
  }

  return (
    <AuthCard testid="reset-panel">
      <form onSubmit={submit} data-testid="reset-form">
        <span className="grid h-11 w-11 place-items-center rounded-xl bg-oath-ink text-white"><KeyRound className="h-5 w-5" /></span>
        <h1 className="mt-6 font-display text-3xl font-bold tracking-tight text-oath-ink">Choose a new password</h1>
        <p className="mt-2 text-sm text-oath-secondary">{email || "…"}</p>
        <label className="mt-6 block font-mono-label text-[10px] font-semibold text-oath-secondary">NEW PASSWORD (MIN 10)</label>
        <Input type="password" required minLength={10} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2" data-testid="reset-password-input" />
        <label className="mt-4 block font-mono-label text-[10px] font-semibold text-oath-secondary">CONFIRM</label>
        <Input type="password" required minLength={10} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-2" data-testid="reset-confirm-input" />
        <button type="submit" disabled={loading} data-testid="reset-submit-button"
          className="mt-6 inline-flex w-full items-center justify-center rounded-full bg-oath-ink px-6 py-3.5 font-mono-label text-[12px] font-semibold text-white hover:bg-black disabled:opacity-60">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "UPDATE PASSWORD"}
        </button>
      </form>
    </AuthCard>
  );
}
